export default __webpack_public_path__ + "static/media/b12.6d166ee1.png";